/* unplugin-vue-components disabled */import script from "./search.vue?vue&type=script&setup=true&lang=js"
export * from "./search.vue?vue&type=script&setup=true&lang=js"

import "./search.vue?vue&type=style&index=0&id=0b27c2af&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/48tk_gai/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b27c2af"]])

export default __exports__